export const SUGGESTED_QUERIES = [
  'Which bookings include onboard credit?',
  'Show all Lux Plus inclusions for Viking',
  'Top 10 departures by booking count',
  'How many bookings were completed last month?',
  'Which vendors have the most active offers?',
  'Show all rate codes for Celebrity Cruises',
  'Which offers have the most departures?',
  'List all flash rate codes with their connected departures',
];
